module.exports = __webpack_public_path__ + "static/img/graph--exponential.8a09f0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Start/graph--exponential.svg
// module id = WQaw
// module chunks = 1